module.exports = __webpack_public_path__ + "media/images/emblems/Kernenried-coat_of_arms-3684073e02fd99010f8abace179689f3.svg";